import script from "./item-group.vue?vue&type=script&lang=ts&setup=true"
export * from "./item-group.vue?vue&type=script&lang=ts&setup=true"

import "./item-group.vue?vue&type=style&index=0&id=72d5f81e&lang=scss&scoped=true"
import "./item-group.vue?vue&type=style&index=1&id=72d5f81e&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72d5f81e"]])

export default __exports__